/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Inspector_TitleInputs */

const cs_pipelines_inspector_title = /** @type {(inputs: Pipelines_Inspector_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze`)
};

const en_pipelines_inspector_title = /** @type {(inputs: Pipelines_Inspector_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Pipelines_Inspector_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_inspector_title = /** @type {((inputs?: Pipelines_Inspector_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Inspector_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_inspector_title(inputs)
	return cs_pipelines_inspector_title(inputs)
});